import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth.js';
import layout from './modules/layout.js';
import dashboard from './modules/dashboard.js';
import acompanhamentoprotesto from './modules/acompanhamento-protesto.js';
import mensagem from './modules/mensagem.js';
import comarca from './modules/comarca.js';
import procurador from './modules/procurador.js';
import peticao from './modules/peticao.js';
import cda from './modules/cda.js';
import tipoCreditoAssunto from './modules/tipoCreditoAssunto.js';
import cnj from './modules/cnj.js';
import agendaPrazo from './modules/agenda-prazo.js';
import minuta from './modules/minuta.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {    
    auth,
    layout,
    dashboard,
    acompanhamentoprotesto,
    mensagem,
    comarca,
    procurador,
    peticao,
    cda,
    tipoCreditoAssunto,
    cnj,
    agendaPrazo,
    minuta
  }
});